export default __webpack_public_path__ + "static/srinivasa_story-411cccba29e8b4e400c8725e0ae9d3bf.png";